<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="Box c-top">
      <div class="table_tab">
        <div class="inquiry">
          <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
          <el-form :inline="true" ref="searchForm" :model="searchForm" label-width="" size="small">
            <el-form-item label="类目名称">
              <el-input placeholder="请输入类目名称" clearable :maxlength="20" v-model.trim="searchForm.categoryName"></el-input>
            </el-form-item>
            <el-form-item label="编号">
              <el-input placeholder="请输入编号" clearable v-model="searchForm.categoryNo"
                oninput="value=value.replace(/[^0-9.]/g,'')" :maxLength="2"></el-input>
            </el-form-item>

            <!-- <el-form-item label="状态">
              <el-select v-model="searchForm.status" placeholder="请选择" clearable>
                <el-option v-for="items in statuss" :key="items.value" :label="items.name"
                  :value="items.value"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <el-button @click="getList()" v-on:keyup.enter="searchEvent" type="primary">查询</el-button>
              <el-button plain @click="reset()" type="primary">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="inquiryTab">
          <div class="tabTitle">列表数据</div>
          <el-table row-key="id" lazy :tree-props="{ children: 'childList', hasChildren: 'hasChildren' }"
            :data="tableData.list" :header-cell-style="{
              background: '#F5F6FA',
              textAlign: 'left',
            }" style="width: 100%; padding: 14px 14px" :toggleRowExpansion="{ expanded: true }" ref="theTable"
            :row-style="{ height: '88px' }">
            <el-table-column label="类目名称" min-width="80" prop="categoryName">
            </el-table-column>
            <el-table-column label="编号" prop="categoryNo" width="200">
              <template slot-scope="props">
                <div style="text-align: left">
                  {{ props.row.categoryNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="排序" prop="sortApp" width="200">
              <template slot-scope="props">
                <div style="text-align: left">
                  <el-input v-model="props.row.sortApp" size="small" @change="changeSort(props.row, $event)"></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="级别" prop="levelDesc">
              <template slot-scope="props">
                <div style="text-align: left">
                  {{ props.row.levelDesc }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" prop="status">
              <template slot-scope="props">
                <div style="display: flex">
                  <div v-if="props.row.status == 'A'" style="
                      width: 10px;
                      height: 10px;
                      background: #13ce4b;
                      border-radius: 50%;
                      opacity: 1;
                      margin-top: 8px;
                      margin-right: 4px;
                    "></div>
                  <div v-else style="
                      width: 10px;
                      height: 10px;
                      background: #f63c56;
                      border-radius: 50%;
                      opacity: 1;
                      margin-top: 8px;
                      margin-right: 4px;
                    "></div>
                  <div>{{ props.row.statusDesc }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="200" label="更新日期" prop="updatedTime">
              <template slot-scope="props">
                <div style="text-align: left">
                  {{ props.row.updatedTime }}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="height: 20px"></div>
        </div>
      </div>
    </div>
    <!-- 分页start -->
    <!-- <div class="page" v-if="tableData.totalNum > 0">
      <div class="block"></div>
    </div> -->
    <!-- 分页end -->
  </div>
</template>

<script>
import VDistpicker from 'v-distpicker'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
export default {
  watch: {

  },
  components: {
    VDistpicker,
    breadcrumbTop,
    breadcrumbSearch
  },
  data() {
    return {
      searchForm: {
        // pageNo: 1,
        // pageSize: 10,
        categoryName: '',
        categoryNo: '',
        status: null
      },
      searchList: {
        list: [
          { title: '类目管理', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '类目管理', path: '', type: '1' }
        ]
      },
      goodsNumber: '',
      dialogVisibleGoods: false,
      disabledStatus: false, // 是否禁用
      toInfoDialogVisible: false, // 新增下级/编辑对话框
      addClassifyDialogVisible: false, // 新增分类对话框
      date: '',
      rowId: '', // 列表行ID
      rowList: [],
      selectedOptions: [],
      position: [
        {
          label: '正常',
          value: 'A'
        },
        {
          label: '停用',
          value: 'S'
        },
        {
          label: '删除',
          value: 'X'
        }
      ],
      options: [],
      btnText: '',
      queryForm: {
        categoryNo: '',
        categoryName: '',
        status: ''
      },
      // 列表树形控件配置参数
      defaultProps: {
        children: 'children',
        categoryName: 'categoryName'
      },
      // 新增下级
      ruleForm: {
        categoryNo: '',
        categoryName: '',
        parentId: '',
        status: 'A',
        value: 0
      },
      cascaderValue: '',
      ruleFormRules: {
        categoryNo: [
          { required: false, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'change' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      // 新增分类
      form: {
        categoryNo: '',
        categoryName: '',
        parentId: '',
        status: 'A'
      },
      rules: {
        categoryNo: [
          { required: false, message: '请输入编号', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'change' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      forbidden: false, // 是否禁用
      pageNo: 1,
      pageSize: 10,
      tableData: {
        list: [],
        totalNum: 0
      },
      loading: false,
      tree: [],
      orgCode: '',
      limits: '',
      parArray: [],
      height: '500px',
      statuss: [
        {
          name: '启用中',
          value: 'A'
        },
        {
          name: '禁用中',
          value: 'S'
        }
      ], // 职位列表数据
      expandRow: []
    }
  },
  mounted() {
    const self = this
    const ph = document.documentElement.clientHeight
    self.height = ph - 350 + 'px'
    window.onresize = function () {
      const ph = document.documentElement.clientHeight
      self.height = ph - 350 + 'px'
    }
  },
  created() {
    this.getList()
  },
  beforeRouteLeave(to, form, next) {
    document.onkeydown = null
    next()
  },

  methods: {
    changeSort(row, e) {
      let data = {
        id: row.id,
        sortApp: Number(e)
      }
      this.axios.post('/categorySort/changeSort', data)
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          }

        })
    },
    handleNodeClick(e) {
      console.log(e, '树形控件')
    },



    getList() {
      this.loading = true
      this.axios.post('/categorySort/treeList', this.searchForm)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.tableData.list = res.data
            // this.tableData.totalNum = res.data.totalNum
            this.loading = false
          }
        })
    },
    // 刷新
    refresh() {
      this.queryForm = {}
      this.queryForm.orgId = ''
      this.getStaffList()
      this.$forceUpdate()
    },
    // 返回
    back() {
      this.$router.go(-1)
    },
    is_null(content) {
      if (content) {
        return false
      } else {
        return true
      }
    },
    // 分页
    handleCurrentChange(val) {
      this.searchForm.pageNo = val
      this.getList()
    },
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    /** *是否正常下拉框的数据请求***/
    /** *重置搜索***/
    reset() {
      this.searchForm = {}
      this.searchForm.orgId = ''
      this.pageSize = 10
      this.pageNo = 1
      this.getList()
      this.forArr(this.tableData.list, false)// 全部收起树形表格
    },
    /** *搜索模拟数据***/
    searchEvent() {
      console.log(this.queryForm)
      // this.pageSize = 10;
      // this.pageNo = 1;
      this.getStaffList()
      this.forArr(this.tableData.list, true)// 全部展开树形表格
    },
    // /** *搜索模拟数据***/
    // forArr (arr, isExpand) { // 展开树形表格
    //   arr.forEach(i => {
    //     this.$refs.theTable.toggleRowExpansion(i, isExpand)
    //     if (i.children) {
    //       this.forArr(i.children, isExpand)
    //     }
    //   })
    // }

  }
}
</script>
<style scoped lang="scss">
::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.el-menu-vertical-demo {
  width: 200px;
  overflow-y: scroll;
  height: 700px;
}

.el-menu-input {
  padding: 0 15px;
  background: #fff;

  /deep/ .el-input__inner {
    height: 30px;
    border: 1px solid #eee;
    margin: 10px 0;
  }
}

.el-menu-vertical-demo::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.btnp {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
  color: #0083ef;
}

.btnp:hover {
  color: #4168e7;
  cursor: pointer;
}

.Box {
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .table_tab {
    width: 100%;
    margin-bottom: 50px;
  }
}

.table {
  border-radius: 5px;
  width: 100%;
}

/deep/.distpicker-address-wrapper select {
  padding: 0rem 0.75rem;
  height: 30px;
  line-height: 30px;
  font-size: 15px;
}

/deep/ .expanded {
  background: #f5f7fa;
  color: #000;
}

/deep/.el-table__expanded-cell[class*="cell"] {
  padding: 0px 50px;
}

/deep/.el-table td,
.el-table th {
  text-align: left;
}

.header {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  padding-bottom: 10px;
}

.inquiry {
  background: #fff;
  padding: 8px 14px 8px 14px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }
}

.inquiryTab {
  background: #fff;
  // padding: 8px 14px 8px 14px;
  border-radius: 5px;

  .el-form {
    margin-top: 10px;
  }

  margin-top: 20px;

  .inquiryTab_header {
    display: flex;
    justify-content: space-between;

    /deep/ .el-button {
      height: 40px;
    }
  }
}

/deep/.el-table__expand-icon>.el-icon {
  color: transparent;
}

.table {
  margin-top: 10px;
  // border: 1px solid #e8eaec;
  border-radius: 0;

  /deep/ .el-input--suffix .el-input__inner {
    background: #409eff;
    color: #fff;
    width: 104px;
    box-shadow: none;
  }

  /deep/ .el-button {
    padding: 10px 13px;
  }
}

.page {
  text-align: right;
  width: 100%;
  background: #f5f5f5;
  padding-right: 30px;
  position: fixed;
  bottom: 0px;
  right: 0px;
  z-index: 5;

  span {
    font-size: 14px;
    color: #666;
    display: inline-block;
    margin-left: 10px;
  }

  .el-pagination {
    display: inline-block;
    vertical-align: middle;
  }
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 200px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
  text-align: left;
}

/deep/.el-table__row:hover {
  color: rgb(45, 125, 223);
}

/deep/.el-dialog__header {
  padding: 20px 20px 20px 20px;
  border-bottom: 1px solid #d9d9d9;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #333333;
}

/deep/.el-dialog {
  border-radius: 10px;
}

/deep/.el-dialog__headerbtn {
  top: 15px;
}

.headerbox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border-bottom: 1px solid #ededed;
  padding-bottom: 10px;
}

.title_left {
  width: 4px;
  height: 16px;
  background: #4c81eb;
  opacity: 1;
  margin-right: 10px;
}

.tabTitle {
  height: 21px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  line-height: 21px;
  color: #303033;
  padding-top: 18px;
  padding-left: 14px;
  margin-bottom: 18px;
}

.headerTitle {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  opacity: 1;
  margin-top: 20px;
  margin-bottom: 15px;
}

/deep/.el-form-item__label {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

.red {
  color: #ff0000;
}

.green {
  color: #67c23a;
}

/deep/.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #d9d9d9;
  margin-top: -20px;
  padding-top: 20px;
}

/deep/.el-table thead {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 22px;
  color: #333333;
  opacity: 1;
}

/deep/.el-table th>.cell {
  text-align: left;
}

/deep/.updatedTime {
  text-align: center !important;
}

.btnClass {
  margin-top: 20px;
  display: flex;
  justify-content: right;
}
</style>
